import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from "react-i18next";

const InputIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.641" height="16.629" viewBox="0 0 11.641 16.629">
        <path id="ic_place_24px" data-name="ic place 24px"
              d="M479.535,144.148a5.816,5.816,0,0,0-5.82,5.812v.009c0,4.365,5.82,10.809,5.82,10.809s5.82-6.444,5.82-10.809a5.815,5.815,0,0,0-5.812-5.82Zm0,7.9a2.079,2.079,0,1,1,2.079-2.079A2.079,2.079,0,0,1,479.535,152.047Z"
              transform="translate(-473.715 -144.148)" fill="#c0bebb"/>
    </svg>
);

const LabelContainer = styled.div`
background-color: #fff;
font-family: Open Sans, sans-serif;;
font-size: 16px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: 1.13;
letter-spacing: normal;
text-align: left;
color: #2c271c;
padding: 18px;
width: 100%;
text-align: left;
border: none;
cursor: pointer;
}`;

const InputContainer = styled.div`
padding-left: 18px;
padding-right: 18px;

:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 15px;
    width: 15px;
    height: 22px;
    background-image:url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="11.641" height="16.629" viewBox="0 0 11.641 16.629"><path id="ic_place_24px" data-name="ic place 24px" d="M479.535,144.148a5.816,5.816,0,0,0-5.82,5.812v.009c0,4.365,5.82,10.809,5.82,10.809s5.82-6.444,5.82-10.809a5.815,5.815,0,0,0-5.812-5.82Zm0,7.9a2.079,2.079,0,1,1,2.079-2.079A2.079,2.079,0,0,1,479.535,152.047Z" transform="translate(-473.715 -144.148)" fill="#c0bebb"/></svg>');

}

}`;


export default function CityStateFilter(props) {
    const [textInput, setTextInput] = React.useState('');
    const {t, i18n} = useTranslation();


    useEffect(
        () => {
            //initAutocomplete()
        },
        []
    );

    const handleChange = (event) => {
        //console.log(event);
        setTextInput(event.target.value);
    }

    return (
        <div>
            <LabelContainer>{t('Filter.By')}</LabelContainer>
            <InputContainer>
                <input onChange={handleChange} name="field-address" id="field-address" className="form-control"
                       placeholder={t('City.State')} autoComplete="off"/>
            </InputContainer>
        </div>
    )

}
